import { useState, useEffect } from "react";
import { DESKTOP_2, TABLET_1, TABLET_2 } from "../../domain/constants";

function getScreenSize() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height,
    };
}

export default function useScreenSize() {
    const [screenSize, setScreenSize] = useState(getScreenSize());

    useEffect(() => {
        function handleResize() {
            setScreenSize(getScreenSize());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return {
        width: screenSize.width,
        height: screenSize.height,
        upTo650: screenSize.width < TABLET_1,
        moreOrEqual650: screenSize.width >= TABLET_1,
        upTo800: screenSize.width < TABLET_2,
        moreOrEqual800: screenSize.width >= TABLET_2,
        upTo1024: screenSize.width < DESKTOP_2,
        moreOrEqual1024: screenSize.width >= DESKTOP_2,
    };
}
